import React from "react";

import styles from "./developerUpdate.module.scss";
const CompanyUpdate = ({ user }) => {
  console.log(user);
  return (
    <div>
      <h1>This page is coming soon</h1>
    </div>
  );
};

export default CompanyUpdate;
